import React from 'react';
import SiteFooter from './SiteFooter';

/**
 * Sticky footer shell - main content grows so footer stays at the bottom on short pages.
 */
export function SiteMain({ children, className = 'flex-1 w-full' }) {
  return <main className={className}>{children}</main>;
}

const SiteLayout = ({ children, className = 'bg-gray-50', showFooter = true }) => (
  <div className={`min-h-screen flex flex-col ${className}`}>
    {children}
    {showFooter && <SiteFooter />}
  </div>
);

export default SiteLayout;
